import React from 'react';
import { Image, Popup } from 'semantic-ui-react';
import { NavLink, useLocation } from 'react-router-dom';
import { shape } from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './style.less';

const Item = ({ item, collapsed }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const active = location.pathname.includes(item.link);
  const renderItem = (item, active) => (
    <NavLink to={item.link} style={{ color: active ? '#0747A6' : '#424242' }}>
      {item.icon && (
        <Image
          className={active ? styles.iconImageActive : styles.iconImage}
          src={item.icon}
          alt="menu icon"
        />
      )}
      <span>
        <span>{t(item.id)}</span>
      </span>
    </NavLink>
  );
  return (
    <li
      className={classNames({
        [styles.menu]: !active,
        [styles.activeMenu]: active,
        [styles.collapsed]: collapsed,
      })}>
      {collapsed ? (
        <Popup
          content={t(item.id)}
          inverted
          position="right center"
          size="tiny"
          trigger={renderItem(item, active)}
        />
      ) : (
        renderItem(item, active)
      )}
    </li>
  );
};

Item.propTypes = {
  item: shape({}).isRequired,
};

Item.defaultProps = {};

export default Item;
